export const STATUS_COMPLETE = 'STATUS_COMPLETE';
export const STATUS_FAILED = 'STATUS_FAILED';
